import React from 'react';
import PropTypes from 'prop-types';

import SurveyTemplateCard from './SurveyTemplateCard';
import { BLANK_SURVEY_TEMPLATE } from './index';

const BlankTemplate = ({ viewSurveyDetail, isTemplateSelected, selectSurvey }) => (
  <div className="row survey-template-list mt-4">
    <SurveyTemplateCard
      surveyTemplate={null}
      viewSurveyDetail={viewSurveyDetail}
      isSelected={isTemplateSelected(BLANK_SURVEY_TEMPLATE)}
      selectSurvey={selectSurvey}
    />
  </div>
);

BlankTemplate.propTypes = {
  viewSurveyDetail: PropTypes.func,
  isTemplateSelected: PropTypes.func,
  selectSurvey: PropTypes.func
};

export default BlankTemplate;



// WEBPACK FOOTER //
// ./src/components/survey-templates/BlankTemplate.js